__turbopack_context__.v({
  "location": "Location-module-scss-module___NoT0q__location",
  "title": "Location-module-scss-module___NoT0q__title",
});
